import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a72ee028-442b-44ea-ad3d-be1abd62a5cf/artifacts/zdjtc3rc_Logo_Falo_com_o_dono-removebg-preview.png";

const Section = ({ n, title, children }) => (
  <section className="space-y-2" data-testid={`termos-secao-${n}`}>
    <h2 className="text-lg font-bold text-[#0A2647]">{n}. {title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-2">{children}</div>
  </section>
);

const Termos = () => (
  <div className="min-h-screen bg-slate-50" data-testid="termos-page">
    <header className="bg-[#0A2647] text-white">
      <div className="max-w-3xl mx-auto px-4 py-6 flex items-center gap-3">
        <img src={LOGO_URL} alt="Falo Com O Dono" className="h-10 w-auto object-contain" />
        <div className="flex-1">
          <h1 className="text-2xl font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>Termos de Uso</h1>
          <p className="text-xs text-slate-300">Última atualização: junho de 2026</p>
        </div>
        <Link to="/" className="text-xs text-[#C5A059] hover:underline inline-flex items-center gap-1" data-testid="termos-voltar">
          <ArrowLeft className="w-3.5 h-3.5" /> Voltar ao site
        </Link>
      </div>
    </header>

    <main className="max-w-3xl mx-auto px-4 py-8 space-y-7 bg-white my-6 rounded-2xl border border-slate-200 sm:px-8">
      <p className="text-sm text-slate-600 leading-relaxed">
        Ao usar o Falo Com O Dono™ — como empresa assinante ou como cliente que avalia — você concorda
        com as condições abaixo.
      </p>

      <Section n="1" title="O que é o serviço">
        <p>
          O Falo Com O Dono é uma plataforma que recebe avaliações de clientes e entrega essas avaliações
          diretamente ao dono da empresa avaliada, além de incentivar avaliações públicas no Google.
        </p>
      </Section>

      <Section n="2" title="Cadastro e responsabilidade da empresa">
        <p>
          A empresa assinante é responsável pela veracidade dos dados cadastrados, pelo uso das credenciais
          de acesso e pelo tratamento adequado das informações dos clientes que avaliam seu estabelecimento.
        </p>
      </Section>

      <Section n="3" title="Dados coletados dos clientes que avaliam (LGPD)">
        <p>
          Ao enviar uma avaliação, o cliente informa nome, WhatsApp, e-mail e, de forma opcional, a data de
          nascimento. Esses dados são tratados conforme a Lei nº 13.709/2018 (LGPD).
        </p>
        <p className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-slate-700" data-testid="termos-clausula-lgpd">
          <strong>Cláusula de uso comercial:</strong> ao enviar uma avaliação, o cliente autoriza que os dados
          informados (nome, WhatsApp, e-mail e data de nascimento, quando preenchida) sejam utilizados pela
          empresa avaliada para comunicações comerciais, como mensagens de relacionamento, ofertas,
          promoções, pesquisas de satisfação e felicitações de aniversário, pelos canais informados. A empresa
          avaliada atua como controladora desses dados e o Falo Com O Dono como operadora, limitando-se a
          armazenar e disponibilizar as informações no painel da empresa.
        </p>
        <p>
          O cliente pode, a qualquer momento, solicitar a confirmação, correção ou exclusão dos seus dados,
          bem como o descadastramento das comunicações, pelo e-mail{' '}
          <a href="mailto:falocomodono@gmail.com" className="text-[#C5A059] font-semibold hover:underline">
            falocomodono@gmail.com
          </a>{' '}
          ou diretamente com a empresa avaliada.
        </p>
      </Section>

      <Section n="4" title="Uso adequado">
        <p>
          É proibido usar a plataforma para enviar conteúdo ilegal, ofensivo, discriminatório ou avaliações
          falsas, bem como para disparar comunicações a pessoas que não forneceram seus dados.
        </p>
      </Section>

      <Section n="5" title="Planos, pagamentos e cancelamento">
        <p>
          Os planos são cobrados conforme as condições apresentadas no momento da contratação. O cancelamento
          pode ser solicitado a qualquer momento e interrompe as cobranças seguintes, sem reembolso de
          períodos já utilizados.
        </p>
      </Section>

      <Section n="6" title="Disponibilidade e limitação de responsabilidade">
        <p>
          Trabalhamos para manter o serviço disponível, mas ele pode sofrer interrupções por manutenção ou
          por falhas de terceiros (hospedagem, WhatsApp, Google, meios de pagamento). O Falo Com O Dono não
          responde pelo conteúdo das avaliações nem pelas tratativas comerciais entre empresa e cliente.
        </p>
      </Section>

      <Section n="7" title="Alterações destes termos">
        <p>
          Estes termos podem ser atualizados. A versão vigente estará sempre publicada nesta página, com a
          data da última atualização.
        </p>
      </Section>

      <Section n="8" title="Contato">
        <p>
          Dúvidas sobre estes termos ou sobre seus dados:{' '}
          <a href="mailto:falocomodono@gmail.com" className="text-[#C5A059] font-semibold hover:underline">
            falocomodono@gmail.com
          </a>.
        </p>
      </Section>
    </main>

    <footer className="bg-[#0A2647] text-slate-400 py-6 text-center text-xs">
      &copy; 2026 FaloComODono&trade;. Todos os direitos reservados.
    </footer>
  </div>
);

export default Termos;
